import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=ac53754a"
import script from "./Heart.vue?vue&type=script&lang=ts"
export * from "./Heart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports